<template>
<!--  临床应用-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="itemData.imgBoxUrl" class="el-image__inner">
      </div>
    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in itemData.numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>

    <div class="contentBox"  >
      <div v-if="itemAll.showdata" v-for="itemAll in  itemData.allData" class="alldata">
      <div class="new_body" v-for="item in itemAll.newDate">
        <div class="new_img">
          <img :src="item.imgUrl" class="new_img_1">

        </div>
        <div class="new_text">
          <div class="new_tatil">
            {{item.text1}}
          </div>
          <div class="new_date">
            {{item.text2}}
          </div>
<!--          <div class="new_count">-->
<!--            {{item.text3}}-->
<!--          </div>-->
          <div class="new_ll" @click="goToItem(item.index)">
            <div class="new_all_p">{{item.text4}}</div>
            <i class="el-icon-caret-right tu"></i>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Mun2 from "./image/mun2";
import {Data} from "./js/clinicalNew";
export default {
  name: "clinical",
  components: {Mun2},
  data() {
    return {
      dataAll: Data,
      itemData: {},
      urlData:"",
      showData:{
        box1: false,
        box2: false,
        img1: false,
        video1: false,
        img2: false,
        video2: false
      },
      numIndex: "1",

    }
  },
  mounted() {
    let that = this;
    console.log("init");
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
    that.init();
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);

      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'ey')
      } else {
        let path = "ey";
        for(let indexNum in that.itemData.numList){
          let itemData= that.itemData.numList[indexNum];
          if(that.urlData == itemData.num){
            path = itemData.path
            break;
          }
        }

        that.handleSelect(that.urlData,path)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      //初始化

      for(let indexNum in that.itemData.allData){
        let itemData= that.itemData.allData[indexNum];

        if(index == itemData.num){
          itemData.showdata = true;
        } else {
          itemData.showdata =false;
        }
      }
    },

    goToItem(index){
      this.$router.push('/clinical?path='+index);
    }
  }
}
</script>

<style scoped>
.new_img_1{
  border-radius: 10px;
  width: 100%;
}
.alldata{
  width: 100%;
}
.new_ll{
  display: flex;
  margin-top: 38px;
}
.new_text{
  margin-top: 30px;
  margin-right: 15px;
  width: 69.39%;
}
.new_img{
  width: 30.61%;
  display: flex;
  align-items: center;
  aspect-ratio: 360/284;
  margin: 20px;
}
.new_all_p{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #63B62E;
  text-align: justify;

}
.tu{
  font-size: 15px;
  color: #63B62E;
}
.new_count{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 28px;
}
.new_date{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #999999;
  text-align: justify;
  margin-bottom: 15px;
}
.new_tatil{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  text-align: justify;
  margin-bottom: 15px;
}
.new_body{
  width: 100%;
  aspect-ratio: 1176/324;
  margin-top: 20px;
  display: flex;
  background-color: #FFFFFF;

}
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.cli_img{
  margin-top: 35px;
  margin-bottom: 25px;
}
.cli_d_2{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
  white-space: pre-wrap;
}
.cli_d_1{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
}
.cu_all{
  width: 1176px;
}
.contentBox {
  width: 61.25%;
  margin: 50px auto;
  display: flex;
  justify-content: center;
}
.productPage {
  display: block;
  width: 100%;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  aspect-ratio: 1920/600;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/clinicalNew.vue